module.exports = __webpack_public_path__ + "img/partner-new4.b703d8b4.png";